module.exports = __webpack_public_path__ + "static/media/cert_992019011.f2dced63.jpg";